import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { Validators } from '@ng-stack/forms';
import { ClassSummary, Student, Vacation, VacationFile } from 'src/app/models/CalendarModels';
import { ClassVacationRequest, StudentVacationRequest, VacationRequest } from 'src/app/models/CalendarRequest';
import { OptionSet } from 'src/app/models/OptionSet';
import { CalendarService } from 'src/app/services/calendar.service';
import { isTemplateExpression } from 'typescript/lib/tsserverlibrary';
import { SaveStudentsDialogComponent } from '../save-students-dialog/save-students-dialog.component';
import { CookieService } from 'ngx-cookie-service';
import { SchedulesService } from 'src/app/services/schedules.service';

@Component({
  selector: 'app-special-vacation',
  templateUrl: './special-vacation.component.html',
  styleUrls: ['./special-vacation.component.scss']
})
export class SpecialVacationComponent implements OnInit {
  public form: FormGroup;
  minDate: Date;
  isSubmited: boolean = false;
  selectedStudents: Student[] = [];
  selectedVacations: Vacation[] = [];
  standaloneNotes: { Note: string }[] = [];
  @Output() callback = new EventEmitter();
  @Input() set selectedVacationsList(item: Vacation[]) {

    this.selectedVacations = item;
    if (item?.length > 0) {
      this.setForm(item[0]);
    }
    else { this.clearForm(); }
  }
  @Input() enableUpdateAll: boolean = false;

  existingFiles: VacationFile[] = [];
  newFiles: VacationFile[] = [];

  constructor(public calendarSvc: CalendarService, public dialog: MatDialog, private cookieService: CookieService, private schedulesSvc: SchedulesService) {

    this.initializeForm();
    this.calendarSvc.studentSelected.subscribe(res => this.selectedStudents = res);
  }

  ngOnInit(): void {
  }

  initializeForm() {
    this.form = new FormGroup({
      FromDate: new FormControl(null, [Validators.required]),
      ToDate: new FormControl(null, [Validators.required]),
      IsShortDay: new FormControl(false),
      EndTime: new FormControl(),
      description: new FormControl(null),
      vacationType: new FormControl(null, Validators.required)
    });
  }
  changefromDate(event: MatDatepickerInputEvent<Date>) {
    this.minDate = event.value;
  }

  setForm(vacation: Vacation) {
    this.form.controls.FromDate.setValue(vacation.Date);
    this.form.controls.ToDate.setValue(vacation.DateTo);
    this.form.controls.IsShortDay.setValue(vacation.IsShortDay);
    // this.form.controls.StartTime.setValue(this.calendarSvc.getOption(vacation.StartTime?.value, this.calendarSvc.ScheduleHoursList));
    this.form.controls.EndTime.setValue(this.calendarSvc.getOption(vacation.EndTime?.value, this.calendarSvc.ScheduleHoursList));
    this.form.controls.vacationType.setValue(this.calendarSvc.getOption(vacation.Period?.value, this.calendarSvc.PeriodDescriptionList));
    this.form.controls.description.setValue(vacation.Description);
    this.checkChosen(null);

    if (vacation.Files && vacation.Files.length > 0) {
      this.existingFiles = vacation.Files.map(file => ({
        FileId: file.FileId,
        FileName: file.FileName,
        Note: file.Note || ''
      }));

      this.standaloneNotes = this.existingFiles
        .filter(f => f.FileName === '__STANDALONE_NOTE__.txt')
        .map(f => ({ Note: f.Note || '' }));

      this.existingFiles = this.existingFiles.filter(f => f.FileName !== '__STANDALONE_NOTE__.txt');
    }
  }

  clearForm() {
    this.form.reset();
    this.isSubmited = false;
    this.newFiles = [];
    this.existingFiles = [];
    this.standaloneNotes = [];
  }

  OnSwitch(ischecked: boolean) {
    this.form.controls.IsShortDay.setValue(ischecked)
    if (ischecked) {
      this.form.controls.EndTime.addValidators(Validators.required);
    }
    else {
      this.form.controls.EndTime.clearValidators();
      this.form.controls.EndTime.setValue(null);
    }
    this.form.controls.EndTime.updateValueAndValidity();
  }

  openSaveStudentsModal() {

    this.isSubmited = true;
    if (!this.form.valid)
      return;

    if (this.selectedStudents.length == 1) {
      this.updateSelectedStudents(/*1*/);
    }
    else {
      const dialogRef = this.dialog.open(SaveStudentsDialogComponent);
      dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed');
        switch (result) {
          case 1://create general vacation for all students
          case 2: //create private vacation to each student
            this.updateSelectedStudents(/*result*/);
            break;
          default://cancel
            break;
        }
      });
    }
  }


  // updateSelectedStudents() {
  //   debugger
  //   this.calendarSvc.spinnerSubjectEmit(true);
  //   let request: StudentVacationRequest = {
  //     Vacation: this.buildVacationModel(),
  //     Students: this.selectedStudents.map(x => {
  //       let s: Student = { ContactId: x.ContactId, Id: x.Id };
  //       return s;
  //     })
  //   };
  //   if (/*action == 2 &&*/ this.selectedVacations?.length == 1) {
  //     request.Vacation.ParentId = this.selectedVacations[0].VacationId;
  //   }
  //   this.calendarSvc.request.StudentVacationRequest = request;
  //   this.calendarSvc.saveStudentVacation().then((res: string) => {
  //     if (!this.calendarSvc.dataService.IsError(res)) {
  //       this.clearForm();
  //       this.callback.emit();
  //     }
  //     this.calendarSvc.spinnerSubjectEmit(false);
  //   }).catch(err => {
  //     debugger
  //     this.calendarSvc.spinnerSubjectEmit(false);
  //   });
  // }

  updateSelectedStudents() {

    this.isSubmited = true;
    if (!this.form.valid)
      return;
    this.calendarSvc.spinnerSubjectEmit(true);

    const standaloneNotesAsFiles = this.standaloneNotes
      .filter(note => note.Note && note.Note.trim() !== '')
      .map(note => {
        const emptyFile = new File([''], '__STANDALONE_NOTE__.txt', { type: 'text/plain' });
        return {
          File: emptyFile,
          FileName: '__STANDALONE_NOTE__.txt',
          Note: note.Note
        } as VacationFile;
      });

    const allNewFiles = [...this.newFiles, ...standaloneNotesAsFiles];

    let request: StudentVacationRequest = {
      Vacation: this.buildVacationModel(),
      Students: this.selectedStudents.map(x => {
        let s: Student = { ContactId: x.ContactId, Id: x.Id };
        return s;
      })
    };
    if (/*action == 2 &&*/ this.selectedVacations?.length == 1) {
      request.Vacation.ParentId = this.selectedVacations[0].VacationId;
      request.Vacation.Id = this.selectedVacations[0].VacationForAccountId;
    }
    this.calendarSvc.request.StudentVacationRequest = request;

    this.calendarSvc.saveStudentVacationWithFiles(request, allNewFiles, this.existingFiles).then((res: string) => {
      if (!this.calendarSvc.dataService.IsError(res)) {
        this.clearForm();
        this.callback.emit();
      }
    }).catch(err => {
      this.calendarSvc.spinnerSubjectEmit(false);
    });
  }

  updateAll() {
    debugger;
    this.isSubmited = true;
    if (!this.form.valid)
      return;
    this.calendarSvc.spinnerSubjectEmit(true);

    const standaloneNotesAsFiles = this.standaloneNotes
      .filter(note => note.Note && note.Note.trim() !== '')
      .map(note => {
        const emptyFile = new File([''], '__STANDALONE_NOTE__.txt', { type: 'text/plain' });
        return {
          File: emptyFile,
          FileName: '__STANDALONE_NOTE__.txt',
          Note: note.Note
        } as VacationFile;
      });

    const allNewFiles = [...this.newFiles, ...standaloneNotesAsFiles];

    var classesSummary = this.groupBy(this.selectedStudents, function (item: Student) {
      return [item.Class, item.ClassCode, item.Classification];
    });

    if (this.selectedStudents.length === 0 && this.schedulesSvc?.selectedClasses?.length > 0) {
      classesSummary = [];

      this.schedulesSvc.selectedClasses.forEach(selectedClass => {

        let hasClassCodesForThisClass = false;

        if (this.schedulesSvc.selectedClassCodes?.length > 0) {
          this.schedulesSvc.selectedClassCodes.forEach(selectedClassAndCode => {
            const classValue = selectedClassAndCode.value.substring(0, 3);

            if (classValue === selectedClass.value) {
              hasClassCodesForThisClass = true;

              const classCodeValue = selectedClassAndCode.value.substring(3);

              const actualClassCode = {
                value: classCodeValue,
                viewValue: selectedClassAndCode.viewValue.replace(selectedClass.viewValue, '')
              };

              const classification = this.schedulesSvc.selectedClassification?.length > 0
                ? this.schedulesSvc.selectedClassification[0]
                : null;

              classesSummary.push({
                Class: selectedClass,
                ClassCode: actualClassCode,
                Classification: classification,
                Students: []
              });
            }
          });
        }

        if (!hasClassCodesForThisClass) {
          const classification = this.schedulesSvc.selectedClassification?.length > 0
            ? this.schedulesSvc.selectedClassification[0]
            : null;

          classesSummary.push({
            Class: selectedClass,
            ClassCode: null,
            Classification: classification,
            Students: []
          });
        }
      });
    }

    let vacationsToUpdate: VacationRequest[] = [];
    if (this.selectedVacations && this.selectedVacations.length > 0) {
      this.selectedVacations.forEach(item => {
        let index = classesSummary.findIndex(x => JSON.stringify(x.Class) == JSON.stringify(item.Class) && JSON.stringify(x.ClassCode == item.ClassCode)
          && JSON.stringify(x.Classification) == JSON.stringify(item.Classification));
        let vacationFromList = this.calendarSvc.classVacationsListFiltered.find(x => x.VacationForAccountId == item.VacationForAccountId);
        let v = new VacationRequest();
        v.Id = item.VacationForAccountId;
        v.ParentId = item.VacationId;
        v.Class = item.Class;
        v.ClassCode = item.ClassCode;
        v.Classification = item.Classification;
        v.Camp = item.Camp;
        v.Students = index > -1 ? classesSummary[index].Students : this.calendarSvc.mapStudentsFromStringToObject(vacationFromList.Students);
        vacationsToUpdate.push(v);
        if (index != -1) { classesSummary.splice(index, 1); }
      });
    }
    let ClassesToCreate = classesSummary.map(x => {
      let v = new VacationRequest();
      v.Class = x.Class;
      v.ClassCode = x.ClassCode;
      v.Classification = x.Classification;
      v.Camp = this.calendarSvc.selectedCamp;
      v.Students = x.Students;
      return v;
    });

    let request: ClassVacationRequest = {
      Vacation: this.buildVacationModel(),
      ClassesToCreate: ClassesToCreate,
      VacationsToUpdate: vacationsToUpdate,
    };
    this.calendarSvc.request.ClassVacationRequest = request;

    this.calendarSvc.saveClassVacationWithFiles(request, allNewFiles, this.existingFiles)
      .then((res: string) => {
        if (!this.calendarSvc.dataService.IsError(res)) {
          this.clearForm();
          this.callback.emit();
        } else {
          this.calendarSvc.spinnerSubjectEmit(false);
        }
      })
      .catch(err => {
        this.calendarSvc.spinnerSubjectEmit(false);
      });
  }

  groupBy(array, f) {
    var groups = {};
    array.forEach(function (o) {
      var group = JSON.stringify(f(o));
      groups[group] = groups[group] || [];
      groups[group].push(o);
    });
    return Object.keys(groups).map(function (group): ClassSummary {
      let x = JSON.parse(group)
      return { Class: x[0], ClassCode: x[1], Classification: x[2], Students: groups[group] };
    })
  }

  buildVacationModel() {
    let vacation: VacationRequest = new VacationRequest();
    vacation.FromDate = this.calendarSvc.transformDate(this.form.controls.FromDate.value, "yyyy-MM-dd");
    vacation.ToDate = this.calendarSvc.transformDate(this.form.controls.ToDate.value, "yyyy-MM-dd");
    vacation.Name = this.form.controls.vacationType.value.viewValue;
    vacation.Period = this.form.controls.vacationType.value;
    if (vacation.Period.viewValue == 'אחר') {
      vacation.Name = this.form.controls.description.value;
      vacation.Description = this.form.controls.description.value;
    }
    vacation.IsShortDay = this.form.controls.IsShortDay.value;
    vacation.StartTime = { value: "800", viewValue: "08:00" };
    vacation.EndTime = this.form.controls.EndTime.value;

    const useLogin = this.cookieService.get('useLogin');

    if (useLogin === 'false') {
      vacation.lastUpdatedByName = this.cookieService.get('SystemUserFullName');;
    } else {
      vacation.lastUpdatedByName = this.cookieService.get('AcountFullName');;
    }
    return vacation;
  }

  checkChosen(event: any) {
    if (!event) return;
    if (this.form.value.vacationType.viewValue == 'אחר') {
      this.elseChosen = true;
      this.form.get("description").addValidators(Validators.required);
    }
    else {
      this.elseChosen = false;
      this.form.get("description").clearValidators();
      this.form.get("description").updateValueAndValidity();
    }
  }

  elseChosen: boolean = false

  onFilesSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const filesArray = Array.from(input.files);
      for (let newFile of filesArray) {
        const exists = this.newFiles.some(f => f.FileName === newFile.name && f.File?.size === newFile.size);
        if (!exists) {
          this.newFiles.push({
            File: newFile,
            FileName: newFile.name,
            Note: ''
          });
        }
      }
      input.value = '';
    }
  }

  downloadFile(fileId: string, fileName: string) {
    this.calendarSvc.downloadVacationFile(fileId).then(blob => {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      link.click();
      window.URL.revokeObjectURL(url);
    });
  }

  addStandaloneNote() {
    this.standaloneNotes.push({ Note: '' });
  }

  removeStandaloneNote(index: number) {
    this.standaloneNotes.splice(index, 1);
  }
}